import React from 'react';
import { object, string, arrayOf, number, func } from 'prop-types';
import TileContainerTable from 'sections/tile-container/TileContainerTable';
import TileContainer from 'sections/tile-container/TileContainer';
import NoItems from './NoItems';
import Resources from '../resources/';
import ItemPagination from './ItemPagination';

export default function ListingItemsSection({
    listingItems, resources, tileContainerColumnClass, tileContainerTilesWrap, tileType,
    totalPages, currentPage, perPage, totalItems, changePage, resetFilters, handleOpenModal,
    refType
}) {
    let itemsResourcesWrapperClass = 'items-resources-wrapper';
    if (resources.length >= 1) {
        itemsResourcesWrapperClass += ' has-resources';
    }
    if (tileType === 'contentTable') { itemsResourcesWrapperClass += ' content-table'; }

    return (
        <div className="listing-items">
            <div className="listing-items-container">
                <div className={itemsResourcesWrapperClass}>
                    <div className="items-wrapper">
                        <NoItems
                            items={listingItems}
                            resetFilters={resetFilters}
                        />
                        {tileType === 'contentTable'
                            ? <TileContainerTable
                                items={listingItems}
                                tileType={tileType}
                                handleOpenModal={handleOpenModal}
                                refType={refType}
                            />
                            : <TileContainer
                                items={listingItems}
                                columnClass={tileContainerColumnClass}
                                tileWrap={tileContainerTilesWrap}
                                tileType={tileType}
                            />
                        }
                        <ItemPagination
                            totalPages={totalPages}
                            currentPage={currentPage}
                            perPage={perPage}
                            totalItems={totalItems}
                            changePage={changePage}
                        />
                    </div>
                    <Resources resources={resources} />
                </div>
            </div>
        </div>
    );
}

ListingItemsSection.propTypes = {
    listingItems: arrayOf(object).isRequired,
    tileContainerColumnClass: string.isRequired,
    tileContainerTilesWrap: string.isRequired,
    tileType: string.isRequired,
    resources: arrayOf(object).isRequired,
    totalPages: number.isRequired,
    currentPage: number.isRequired,
    perPage: number.isRequired,
    totalItems: number.isRequired,
    changePage: func.isRequired,
    resetFilters: func.isRequired,
    handleOpenModal: func.isRequired,
    refType: string
};

ListingItemsSection.defaultProps = { refType: 'client' };
